import { ReebeloStoreT } from '@lambda/reebelo';
import { CategoryItemT } from './types';

const Smartphones: CategoryItemT = {
  name: 'Smartphones',
  value: 'smartphones',
  categoryPk: '02h610t3d104',
};

const Laptops: CategoryItemT = {
  name: 'Laptops',
  value: 'laptops',
  categoryPk: '05t394s0h4e1',
};

const Tablets: CategoryItemT = {
  name: 'Tablets',
  value: 'tablets',
  categoryPk: '05t3a2p3p2b0',
};

const Smartwatches: CategoryItemT = {
  name: 'Smartwatches',
  value: 'smartwatches',
  categoryPk: '02h610t3d120',
};

const Audio: CategoryItemT = {
  name: 'Audio',
  value: 'audio',
  categoryPk: '02h610t3d250',
};

const Fashion: CategoryItemT = {
  name: 'Fashion',
  value: 'fashion',
  categoryPk: '1263a5e4b474',
};

const Handbags: CategoryItemT = {
  name: 'Handbags',
  value: 'handbags',
  categoryPk: '1270p1r5j7q1',
};

const Sports: CategoryItemT = {
  name: 'Sports',
  value: 'sports',
  categoryPk: '02h610t3d134',
};

const Home: CategoryItemT = {
  name: 'Home',
  value: 'home',
  categoryPk: '02n5t7v7l3p4',
};

export const CUSTOMER_FAVORITES: Partial<
  Record<ReebeloStoreT, CategoryItemT[]>
> = {
  'reebelo-us': [
    Smartphones,
    Laptops,
    Tablets,
    Smartwatches,
    Audio,
    Fashion,
    Handbags,
    Sports,
    Home,
  ],
  'reebelo-uk': [Smartphones, Tablets, Laptops, Smartwatches],
  'reebelo-au': [Smartphones, Laptops, Tablets, Smartwatches, Audio, Home],
  'reebelo-nz': [Smartphones, Laptops, Tablets, Smartwatches, Audio, Home],
  quista: [Smartphones, Laptops, Tablets, Smartwatches, Audio],
  'reebelo-ca': [Smartphones, Laptops, Tablets, Smartwatches, Audio],
  'reebelo-fr': [Smartphones, Laptops, Tablets, Smartwatches],
  'reebelo-de': [Smartphones, Laptops, Tablets, Smartwatches],
  'reebelo-es': [Smartphones, Laptops, Tablets, Smartwatches],
  'reebelo-it': [Smartphones, Laptops, Tablets, Smartwatches],
  'reebelo-se': [Smartphones, Laptops, Tablets, Smartwatches],
};
